<template>
  <teleport to="#app">
    <div
      :id="id" tabindex="-1" data-bs-scroll="true"
      class="offcanvas offcanvas-start border-dark border-end rounded-end border-5 ms-60 w-260 mt-md-60"
    >
      <div class="offcanvas-header">
        <h6 class="offcanvas-title">
          {{ title.toUpperCase() }}
        </h6>
      </div>
      <div class="offcanvas-body">
        <ul class="list-group">
          <SubMenuItem v-for="submenuItem in submenu" :key="submenuItem.title" v-bind="submenuItem" />
        </ul>
      </div>
    </div>
  </teleport>
</template>

<script>
import SubMenuItem from './SideBarSubMenuItem.vue';
import { Offcanvas } from 'bootstrap';
import eventbus from '@/modules/core/services/eventbus';

export default {
  components: { SubMenuItem },
  props: {
    title: { type: String, required: true },
    submenu: { type: Array, default: null },
  },
  data: (props) => ({ instance: null, id: `canvas_${props.title}` }),
  mounted() {
    this.instance = new Offcanvas(`#${this.id}`);
    eventbus.on('sidebar.opened', this.onOpenedSidebar);
  },
  beforeUnmount() {
    this.instance.dispose();
    eventbus.off('sidebar.opened', this.onOpenedSidebar);
  },
  methods: {
    onOpenedSidebar(opened) { !opened && this.instance.hide(); },
  },
};
</script>

<style scoped>
  .w-260 { width: 260px !important; }
  .ms-60 { margin-left: 60px; }
  @media (max-width: 767px) {
    .mt-md-60 { margin-top: 60px; }
  }
</style>
